"use client";

import { useAppSetting } from "@/shell/hooks/useBootstrap";
import type { AppVisualIdentityContent, PlatformTheme } from "@/shared/settings";

/**
 * Tema web do cliente (cores, estrutura, componentes, logo) via bootstrap.
 * Para estilizar, prefira as classes do tema (bg-primary, rounded-box...);
 * use este hook quando precisar dos VALORES — templates de header/footer,
 * config de card/busca, logo da interface.
 */
export function useTheme(): PlatformTheme | null {
    const identity = useAppSetting<AppVisualIdentityContent>("app_visual_identity");

    return identity?.web ?? null;
}
